import { apiService } from './api';
import {
  IssueNoteDTO,
  IssueNoteListDTO,
  IssueNoteApprovalStatusDTO,
  IssueNoteStatsDTO,
  CreateIssueNoteRequest,
} from '../types';

const API = '/issue-notes';

export const issueNoteService = {
  // ── CRUD ──────────────────────────────────────────────────────────────────

  getAll: (pageNumber = 1, pageSize = 50) =>
    apiService.get<{ data: IssueNoteListDTO[]; pagination: { total: number; page: number; pageSize: number } }>(
      API, { pageNumber, pageSize }
    ),

  getById: (id: number | string) =>
    apiService.get<IssueNoteDTO>(`${API}/${id}`),

  getStats: () =>
    apiService.get<IssueNoteStatsDTO>(`${API}/stats`),

  create: (data: CreateIssueNoteRequest) =>
    apiService.post<IssueNoteDTO>(API, data),

  update: (id: number | string, data: Partial<CreateIssueNoteRequest> & { items: CreateIssueNoteRequest['items'] }) =>
    apiService.put<IssueNoteDTO>(`${API}/${id}`, data),

  delete: (id: number | string) =>
    apiService.delete<boolean>(`${API}/${id}`),

  // ── Workflow ──────────────────────────────────────────────────────────────

  submit: (id: number | string, submittedByUserId: number) =>
    apiService.post<IssueNoteApprovalStatusDTO>(`${API}/${id}/submit`, { submittedByUserId }),

  getApprovalStatus: (id: number | string) =>
    apiService.get<IssueNoteApprovalStatusDTO>(`${API}/${id}/approvals`),

  approve: (approvalId: number, userId: number, comments?: string) =>
    apiService.post<IssueNoteApprovalStatusDTO>(
      `${API}/approvals/${approvalId}/approve`,
      { userId, comments }
    ),

  reject: (approvalId: number, userId: number, rejectionReason: string) =>
    apiService.post<IssueNoteApprovalStatusDTO>(
      `${API}/approvals/${approvalId}/reject`,
      { userId, rejectionReason }
    ),

  post: (id: number | string, postedByUserId: number) =>
    apiService.post<IssueNoteDTO>(`${API}/${id}/post`, { postedByUserId }),

  cancel: (id: number | string) =>
    apiService.post<IssueNoteDTO>(`${API}/${id}/cancel`, {}),
};
